import type { LinkProps } from '@/components/ui/link';

import { useHrefFromTo } from './useHrefFromTo';

export function useAbsoluteUrl(to: LinkProps['to']): string {
  const href = useHrefFromTo(to);
  const url = new URL(href, window.location.origin);
  return url.toString();
}
